export default function XQuery_Add() {
  return (
    <div>
      <h1>XQuery_Add</h1>
      <p>This is the XQuery_Add component.</p>
    </div>
  );
}